// import { Welcome } from "./sample/Welcome";

import React from "react";

import OutlinedCard from "./modules/sidePan";

export default function Tab() {
  return (
    <div>
      <OutlinedCard />
    </div>
  );
}
